/**
 * Minimal inline markdown for trusted CMS copy: **bold** only.
 * Escapes HTML first, then converts bold markers.
 */
export function inlineMarkdownToSafeHtml(text: string): string {
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  return escaped.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
}
